import { createContext, type ReactNode, useContext } from 'react'

/**
 * Slot for embedding the Process Data workbench inside feature surfaces. The
 * workbench lives in /pages, which features cannot import, so the hosting
 * page installs a renderer here.
 */
/** What the embedded chart shows after the user acts on it: zoom, pens, axes. */
export interface EmbeddedTrendView {
  start: string
  end: string
  interval?: number
  intervalUnit?: string
  sensorIds: string[]
  hiddenSensorIds: string[]
  customAxisRanges: Record<string, { min?: number; max?: number }>
  singleScale: boolean
}

export interface EmbeddedTrendWorkbenchProps {
  siteId: string
  orgId?: string
  sensorIds?: string[]
  start?: string
  end?: string
  computedKey?: string
  onViewChange?: (view: EmbeddedTrendView) => void
}

export type EmbeddedTrendWorkbenchRenderer = (
  props: EmbeddedTrendWorkbenchProps
) => ReactNode

const EmbeddedWorkbenchContext =
  createContext<EmbeddedTrendWorkbenchRenderer | null>(null)

export const EmbeddedWorkbenchProvider = EmbeddedWorkbenchContext.Provider

export const useEmbeddedTrendWorkbench =
  (): EmbeddedTrendWorkbenchRenderer | null =>
    useContext(EmbeddedWorkbenchContext)
